import { Banner, Footer, Scrollbar } from "./components";


const Home = () => {
    return (
        <>
            {/* <Banner /> */}
            {/* <Scrollbar /> */}
            <Footer />
        </>
    );
};

export default Home;
